var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6942 10.3114C14.284 10.5899 14.9421 10.7464 15.6364 10.7464C18.1528 10.7464 20.2 8.69921 20.2 6.18278C20.2 3.66634 18.1528 1.61914 15.6364 1.61914C14.9421 1.61914 14.284 1.77565 13.6942 2.0542C14.1403 2.62874 14.4955 3.27696 14.7384 3.97725C14.9784 4.66874 15.1091 5.4107 15.1091 6.18278C15.1091 6.95485 14.9784 7.69681 14.7384 8.3883C14.4955 9.08859 14.1403 9.73681 13.6942 10.3114Z",
    fill: "#1E1A1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8298 12.9669C15.6668 13.6185 16.403 14.3933 17.0117 15.2639C18.0102 16.6923 18.6647 18.3781 18.8529 20.2005C18.8899 20.5592 18.909 20.923 18.909 21.2914C18.909 21.6738 18.8425 22.0408 18.7214 22.3823H22.9091C23.5116 22.3823 24 21.8938 24 21.2914C24 16.6797 20.2481 12.9277 15.6364 12.9277C15.3663 12.9277 15.0972 12.941 14.8298 12.9669Z",
    fill: "#1E1A1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36369 10.7464C9.84652 10.7464 11.1659 10.0351 12 8.9363C12.5814 8.17034 12.9273 7.21638 12.9273 6.18278C12.9273 5.14918 12.5814 4.19521 12 3.42925C11.1659 2.33041 9.84652 1.61914 8.36369 1.61914C5.84725 1.61914 3.80005 3.66634 3.80005 6.18278C3.80005 8.69921 5.84725 10.7464 8.36369 10.7464Z",
    fill: "#1E1A1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.09091 22.3823H15.6364C16.2388 22.3823 16.7273 21.8938 16.7273 21.2914C16.7273 20.9217 16.7028 20.5576 16.6561 20.2005C16.4052 18.2824 15.5017 16.567 14.1767 15.2843C13.5394 14.6675 12.8049 14.1506 11.9984 13.7597C10.8986 13.2269 9.66545 12.9277 8.36364 12.9277C3.75193 12.9277 0 16.6797 0 21.2914C0 21.8938 0.488436 22.3823 1.09091 22.3823Z",
    fill: "#1E1A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployees);
export default __webpack_public_path__ + "static/media/Employees.f60b7a800504a3f5fa4abfe6d996ac12.svg";
export { ForwardRef as ReactComponent };